import { apiTypes } from "shared/consts/handbooksApiTypes";

const config = {
  schema: 'mgt',
  table: 'vehicle_model',
  title: 'Модели ТС',
  apiType: apiTypes.REPORT_API,
  elemsOnPage: 100,
  connections: {},
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      disableFilter: true
    },
    {
      name: 'name',
      title: 'Наименование модели',
      type: 'text',
      required: false,
      maxLengthValue: 255,
    },
    {
      name: 'doorsCount',
      title: 'Количество дверей',
      type: 'number',
      required: true,
      minValue: 0,
      maxValue: 10,
    },
  ],
  newTemplate: {
    id: null,
    model: null,
    doorsCount: null,
  },
  updateField: 'update_date',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'model',
        field: 'model',
      },
      {
        title: 'doorsCount',
        field: 'doorsCount',
      },
    ],
    example: `AAAA;10`,
  },
};

export default config;
